import { render, staticRenderFns } from "./PcaPlotsSidebar.vue?vue&type=template&id=ccefebe2&scoped=true"
import script from "./PcaPlotsSidebar.vue?vue&type=script&lang=js"
export * from "./PcaPlotsSidebar.vue?vue&type=script&lang=js"
import style0 from "./PcaPlotsSidebar.vue?vue&type=style&index=0&id=ccefebe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccefebe2",
  null
  
)

export default component.exports